import React, { useMemo } from 'react';

import uniqueId from 'lodash/uniqueId';

import { PageInformationContext } from '@/context/PageInformationContext';
import type { ToolResultContentPart } from '@/features/AIChat/context/utils';
import type { MarketApps } from '@/features/Dashboard/types';
import { useMarketPreview } from '@/features/Markets/api';
import MarketsComponents from '@/pages/Markets/MarketsComponents';

export function constructTemplatePreview(data: ToolResultContentPart) {
  const template: MarketApps = [
    {
      id: uniqueId('ai-chat-apps'),
      tabs: [
        {
          id: uniqueId('ai-chat-table'),
          name: 'Data Table',
          type: 'table',
          metadata: {
            start_date: data.metadata?.start_date ?? '',
            end_date: data.metadata?.end_date ?? ''
          },
          sections: [
            {
              name: '',
              rows: data.rows.map(row => ({
                shortTitle: row.title,
                symbol: {
                  key: {
                    Code: row.code,
                    PeriodType: row.period_type,
                    Period: '1',
                    TimeRef: row.time_ref.toString()
                  },
                  group: 'Prod_Indexes'
                },
                diffSymbol: {
                  key: {
                    Code: '',
                    PeriodType: '',
                    Period: '',
                    TimeRef: ''
                  },
                  group: 'Prod_Indexes'
                }
              }))
            }
          ]
        }
      ]
    }
  ];
  return template;
}

const WidgetMapper = ({ widgetData }: { widgetData: ToolResultContentPart }) => {
  const template = useMemo(() => constructTemplatePreview(widgetData), [widgetData]);
  const { data } = useMarketPreview(template);

  return (
    <PageInformationContext value={{ mainPageTitle: 'AI Chat' }}>
      {data && (
        <MarketsComponents
          forChat
          showAddToDashboard
          components={data.components}
          showShareBlock={false}
        />
      )}
    </PageInformationContext>
  );
};

export default React.memo(WidgetMapper);
